import React from 'react';
import Element from '../element';
import useStyles from './style';

const PrivacyPolicy = () => {
  const classes = useStyles();
  return (
    <Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        Effective Date: November 15, 2021
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        Thorne HealthTech, Inc. (“Thorne,” “we,” “our,” and/or “us”) values the
        privacy of individuals who use our websites, mobile application, and
        related services (collectively, our “Services”). Our privacy policy
        (“our Privacy Policy”) explains how we collect, use, and share
        information from users of our Services (“Users”, “you”, and/or “your”).
        By using our Services, you agree to the collection, use, disclosure, and
        procedures our Privacy Policy describes. Beyond our Privacy Policy, your
        use of our Services is also subject to our Terms of Use
        (https://www.thorne.com/terms-of-use).
      </Element>
      <Element
        type="p"
        fontSize="18px"
        fontFamily="GTAM"
        marginTop="50px"
        margin="16px 0 !important"
      >
        INFORMATION WE COLLECT
      </Element>
      <div className={classes.borderBottom}></div>
      <Element fontFamily="GTAR" fontSize="14px">
        We may collect a variety of information from or about you or your
        devices from various sources, as described below.
      </Element>
      <Element
        type="p"
        fontSize="16px"
        fontFamily="GTAM"
        margin="16px 0 !important"
      >
        Information You Provide to Us
      </Element>
      <Element fontFamily="GTAR" fontSize="14px">
        When a user visits one of our websites, information that personally
        identifies the user can be collected and processed by Thorne Research
        employees. Usually, the only information that will be collected is the
        user’s name, business address, mailing address, telephone number, fax
        number, e-mail address, and professional licensing information when this
        information is knowingly provided to us. In addition, this information
        can be collected as a result of the services or the products a user
        requests information about or purchases from us. Finally, Thorne
        Research can collect or process personally identifiable information,
        such as a user’s Internet domain or IP address, as part of the normal
        operation of our websites, or during the normal course of a user’s
        activities on or use of our websites. In nearly all cases this data is
        collected or processed by, or transferred to, Thorne Research's
        corporate headquarters. When a user visits our websites, the user is
        consenting to the collection, processing, transfer, or use of this
        information. If a user chooses not to consent to the collection,
        processing, transfer, or use of this information in this manner, then
        the user should not visit, or should discontinue visiting, our websites.
        <br />
        <br />
        Account Information. If you sign up for an account on our Services, then
        we ask for information about you, such as your name, mailing address,
        email address, telephone number, and birth date. We may also give you
        the option to provide additional information, such as your professional
        licensing information if you are a licensed health-care practitioner.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Communications.</strong> If you contact us directly, then we may
        receive additional information about you. For example, if you contact us
        for customer support, then we may receive your name, email address,
        telephone number, the contents of the message, and any attachments you
        send to us, as well as any other information you choose to provide. If
        you sign up to receive updates, offers, or other promotional
        information, then we will collect certain information from you, such as
        your email address. You can unsubscribe from our promotional emails via
        the link provided in the emails. Please note that even if you opt out
        from receiving promotional messages from us, you will continue to
        receive administrative messages from us.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Payment Information.</strong> If you make a purchase through our
        Services, then we ask for information, such as your name, email address,
        telephone number, shipping address, and billing address. Your payment
        information, such as your credit card information or other financial
        information, will also be collected and processed by a third-party
        payment processor on our behalf.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Health and Wellness Information.</strong>
        To provide testing services (including generating meaningful results),
        we request certain health and wellness information from you, including
        your height and weight, demographic information, health history,
        medication history, and dietary, sleep, and exercise habits (“Health and
        Wellness Information”). With your consent, we use your Health and
        Wellness Information, your test results, and information about the
        purchases you make through our Services for research, analytics, and
        product development purposes and to create de-identified or aggregate
        data that we might share with third parties for their own research and
        product development purposes. In addition, if you are a customer of one
        of our third-party partners and you use our Services as part of a
        promotion with that partner, with your consent, we will share your test
        results with that third-party partner.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong> Quizzes.</strong>
        If you choose to participate in one of our quizzes to help you identify
        which Thorne products are right for you, then we collect information you
        choose to provide in response to the quiz, such as your contact
        information, demographic information, and health and medical
        information.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong> Biological Sample.</strong>
        To use our tests, we may require a biological sample, such as a saliva,
        urine, blood, or stool sample. We use your biological sample to provide
        your test results.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong> Other Content.</strong>
        We also receive other information or content you choose to provide to us
        through the Services, such as product ratings and reviews you choose to
        post to the Services. Please see the “User Content” disclosure in the
        “How We Share the Information We Collect” section, below, for
        information about how this information or content is viewable by other
        users of our Services.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Applications.</strong>
        If you submit an application through the Services, such as for an open
        employment position or to become a Thorne ambassador, then we collect
        your name, email address, and address. Applicants are asked, but not
        required, to share links to their social media profile.
      </Element>
      <Element
        type="p"
        fontSize="16px"
        fontFamily="GTAM"
        marginTop="40px"
        margin="16px 0 !important"
      >
        Information We Collect Automatically When You Use Our Services
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Information from Cookies and Similar Technologies. </strong>
        We and our third-party partners collect information using cookies, pixel
        tags, or similar technologies. Our third-party partners, such as
        analytics partners and advertising partners, may use these technologies
        to collect information about your online activities and across different
        services. Cookies are small text files containing a string of
        alphanumeric characters. We may use session cookies and persistent
        cookies. A session cookie disappears after you close your browser. A
        persistent cookie remains after you close your browser and can be used
        by your browser on subsequent visits to our Services. Please review your
        web browser’s “Help” file to learn the proper way to modify your cookie
        settings. Please note that if you delete or choose not to accept cookies
        from the Services, then you might not be able to utilize the features of
        the Services to their fullest potential.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Location Information.</strong>
        If you choose to use certain features of our Services, such as to find a
        licensed health-care practitioner near you, then we receive location
        information you choose to provide to us, such as your city or Zip Code,
        or, with your permission, we receive your precise location information.
        We may also infer your general location information; for example, by
        using your internet protocol (IP) address.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Device Information.</strong>
        We receive information about the device and software you use to access
        our Services, such as your IP address, web browser type, and operating
        system version.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Usage Information. </strong>
        To help us understand how you use our Services and to help us improve
        them, we automatically receive information about your interactions with
        our Services, such as the pages or other content you view, the searches
        you conduct, the products you purchase, your favorites and comments,
        content you post, and the dates and times of your visits.
      </Element>
      <Element
        type="p"
        fontSize="18px"
        fontFamily="GTAM"
        marginTop="50px"
        margin="16px 0 !important"
      >
        HOW WE USE THE INFORMATION WE COLLECT
      </Element>
      <div className={classes.borderBottom}></div>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        We may use the information we collect:
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <ul className={classes.listStyle}>
          <li>To provide, maintain, improve, and enhance our Services.</li>
          <li>
            To personalize your experience on our Services, such as by providing
            tailored content and recommendations.
          </li>
          <li>
            To understand and analyze how you use our Services and develop new
            products, services, features, and functionality.
          </li>
          <li>
            To communicate with you, provide you with updates and other
            information relating to our Services, provide information that you
            request, respond to comments and questions, and otherwise provide
            customer support.
          </li>
          <li>
            To allow you to post content on social networks and other online
            services.
          </li>
          <li>
            For marketing and advertising purposes, such as developing and
            providing promotional and advertising materials that is relevant,
            valuable, or otherwise of interest to you.
          </li>
          <li>For research and analytics purposes.</li>
          <li>
            To generate de-identified or aggregate data that we share with third
            parties for their own research and product development purposes.
          </li>
          <li>To facilitate transactions and payments.</li>
          <li>To evaluate employment applications.</li>
          <li>
            To find and prevent fraud and respond to trust and safety issues
            that arise.
          </li>
          <li>
            For compliance purposes, including enforcing our Terms of Use or
            other legal rights, or as might be required by applicable laws and
            regulations or requested by judicial process or a governmental
            agency.
          </li>
          <li>
            For other purposes for which we provide specific notice at the time
            the information is collected.
          </li>
        </ul>
      </Element>
      <Element
        type="p"
        fontSize="18px"
        fontFamily="GTAM"
        marginTop="50px"
        margin="16px 0 !important"
      >
        HOW WE SHARE THE INFORMATION WE COLLECT
      </Element>
      <div className={classes.borderBottom}></div>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Affiliates. </strong>
        We may share information we receive with our corporate affiliates for
        the purposes described in our Privacy Policy.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Vendors and Service Providers. </strong>
        We may share information we receive with vendors and service providers
        retained in connection with the provision of our Services.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>User Content. </strong>
        Our Services allow you to find and share content, such as product
        ratings and reviews. The content you post to the Services will be
        displayed on the Services and be viewable by other users by default.
        Please note that we are not responsible for the other users’ use of
        available information, so you should carefully consider whether to post
        and what to post or how you identify yourself on the Services.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Social Networks and Other Online Services. </strong>
        Our Services allow you, on your direction, to share content on social
        networks and other online services, such as Twitter and Facebook. You
        understand and agree that the use of the content you post by a social
        networking website or other online service is governed by the privacy
        policies of these third-party services and your settings on that
        service. We encourage you to review their privacy policies.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Analytics Partners. </strong>
        We use analytics services, such as Google Analytics, to collect and
        process certain analytics data. You can learn more about Google’s
        practices by visiting https://www.google.com/policies/privacy/partners/.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Advertising Partners. </strong>
        We work with third-party advertising partners to show you ads we think
        might interest you. Some advertising partners are members of the Network
        Advertising Initiative (https://optout.networkadvertising.org) or the
        Digital Advertising Alliance (https://optout.aboutads.info). If you do
        not wish to receive personalized ads, then visit their opt-out pages to
        learn how you can opt out of receiving web-based personalized ads from
        member companies. You can access settings offered by your mobile
        operating system to limit ad tracking, or you can install the AppChoices
        mobile app to learn how you can opt out of personalized ads in mobile
        apps.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Third-party Partners. </strong>
        With your consent, we de-identify or aggregate your Health and Wellness
        Information and share it, along with your test results and information
        about products you have purchased, with third parties for their own
        research and product development purposes. In addition, if you are a
        customer of one of our third-party partners and you use our Services as
        part of a promotion with that partner, with your consent, Thorne will
        share your test results with that third-party partner.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>As Required by Law and Similar Disclosures. </strong>
        We may access, preserve, and disclose your information if we believe
        doing so is required or appropriate to: (a) comply with law enforcement
        requests and legal process, such as a court order or subpoena; (b)
        respond to your requests; or (c) protect your, our, or others’ rights,
        property, or safety. For the avoidance of doubt, the disclosure of your
        information can occur if you post objectionable content on or through
        the Services.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Merger, Sale, or Other Asset Transfers. </strong>
        We can transfer your information to service providers, advisors,
        potential transactional partners, or other third parties in connection
        with the consideration, negotiation, or completion of a corporate
        transaction in which we are acquired by or merged with another company
        or we sell, liquidate, or transfer all or a portion of our assets. The
        use of your information following such an event will be governed by the
        provisions of our Privacy Policy in effect at the time the applicable
        information was collected.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <strong>Consent. </strong>
        We might also disclose your information with your permission.
      </Element>
      <Element
        type="p"
        fontSize="18px"
        fontFamily="GTAM"
        marginTop="50px"
        margin="16px 0 !important"
      >
        THIRD PARTIES
      </Element>
      <div className={classes.borderBottom}></div>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        Our Services can contain links to other websites, products, or services
        that we do not own or operate. We are not responsible for the privacy
        practices of these third parties. Please be aware that our Privacy
        Policy does not apply to your activities on these third-party services
        nor to information you disclose to these third parties. We encourage you
        to read their privacy policies before providing information to them.
      </Element>
      <Element
        type="p"
        fontSize="18px"
        fontFamily="GTAM"
        marginTop="50px"
        margin="16px 0 !important"
      >
        SECURITY
      </Element>
      <div className={classes.borderBottom}></div>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        We make reasonable efforts to protect your information by using
        safeguards designed to improve the security of the information we
        maintain. However, because no electronic transmission or storage of
        information can be completely secure, we make no guarantee or warranty
        as to the security or privacy of your information.
      </Element>
      <Element
        type="p"
        fontSize="18px"
        fontFamily="GTAM"
        marginTop="50px"
        margin="16px 0 !important"
      >
        CHILDREN
      </Element>
      <div className={classes.borderBottom}></div>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        We do not knowingly collect, maintain, or use personal information from
        children younger than 13 years of age, and no part of our Services is
        directed toward children. If you learn that a child has provided us with
        personal information in violation of our Privacy Policy, then you can
        alert us at info@thorne.com.
      </Element>
      <Element
        type="p"
        fontSize="18px"
        fontFamily="GTAM"
        marginTop="50px"
        margin="16px 0 !important"
      >
        INTERNATIONAL TRANSFERS OF DATA
      </Element>
      <div className={classes.borderBottom}></div>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        Our Services are hosted in the United States and intended for visitors
        located within the United States. If you choose to use the Services from
        the European Union or another region of the world with laws governing
        data collection and use that may differ from U.S. law, then please note
        that you are transferring your personal information outside of those
        regions to the United States for storage and processing. Also, we can
        transfer your data from the United States to other countries or regions
        in connection with storage and processing of data, fulfilling your
        requests, and operating the Services. By providing information,
        including personal information, on or to the Services, you consent to
        such transfer, storage, and processing.
      </Element>
      <Element
        type="p"
        fontSize="18px"
        fontFamily="GTAM"
        marginTop="50px"
        margin="16px 0 !important"
      >
        ADDITIONAL INFORMATION FOR CALIFORNIA RESIDENTS
      </Element>
      <div className={classes.borderBottom}></div>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        The California Consumer Privacy Act (“CCPA”) requires us to provide
        Users who reside in California with the additional notice below.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        We collect and disclose for a business purpose the following categories
        of Personal Information about Users to the following categories of third
        parties (for the purposes of this section of our Privacy Policy,
        “Personal Information” has the meaning provided in the CCPA):
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <table className={classes.borderRight}>
          <thead>
            <tr>
              <th style={{ width: '50%' }}>Category of Personal Information</th>
              <th style={{ width: '50%' }}>
                Third Parties with which we can share Personal Information
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <Element fontFamily="GTAR" fontSize="14px">
                  <strong>Identifiers,</strong> such as name, postal address,
                  internet protocol address, email address, or other similar
                  identifiers.
                </Element>
              </td>
              <td>
                <Element fontFamily="GTAR" fontSize="14px">
                  Vendors and service providers.
                </Element>
                <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
                  Advertising partners.
                </Element>
                <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
                  Analytics partners.
                </Element>
                <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
                  Third parties as required by law or similar disclosures.
                </Element>
              </td>
            </tr>
            <tr>
              <td>
                <Element fontFamily="GTAR" fontSize="14px">
                  <strong>
                    Categories of Personal Information in California Civil Code
                    Section 1798.80(e),{' '}
                  </strong>
                  such as name, physical characteristics or description,
                  address, telephone number, education, employment, employment
                  history, credit card number, debit card number, or any other
                  financial information, or medical information.
                </Element>
              </td>
              <td>
                <Element fontFamily="GTAR" fontSize="14px">
                  Vendors and service providers.
                </Element>
                <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
                  Third parties as required by law or similar disclosures.
                </Element>
              </td>
            </tr>
            <tr>
              <td>
                <Element fontFamily="GTAR" fontSize="14px">
                  <strong>
                    Characteristics of protected classifications under
                    California or federal law,
                  </strong>
                  such as race or color, age (over 40), mental or physical
                  disability, sex (including gender and pregnancy, childbirth,
                  breastfeeding or related medical conditions), or medical
                  condition.
                </Element>
              </td>
              <td>
                <Element fontFamily="GTAR" fontSize="14px">
                  Vendors and service providers.
                </Element>
                <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
                  Third parties as required by law or similar disclosures.
                </Element>
              </td>
            </tr>
            <tr>
              <td>
                <Element fontFamily="GTAR" fontSize="14px">
                  <strong>Commercial Information,</strong> such as records of
                  products or services purchased, obtained, or considered, or
                  other purchasing or consuming histories or tendencies.
                </Element>
              </td>
              <td>
                <Element fontFamily="GTAR" fontSize="14px">
                  Vendors and service providers.
                </Element>
                <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
                  Advertising partners.
                </Element>
                <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
                  Analytics partners.
                </Element>
                <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
                  Third parties as required by law or similar disclosures.
                </Element>
              </td>
            </tr>
            <tr>
              <td>
                <Element fontFamily="GTAR" fontSize="14px">
                  <strong>
                    Internet or other electronic network activity information,
                  </strong>
                  such as information regarding your interaction with an
                  internet website, application, or advertisement.
                </Element>
              </td>
              <td>
                <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
                  Advertising partners.
                </Element>
                <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
                  Third parties as required by law or similar disclosures.
                </Element>
              </td>
            </tr>
            <tr>
              <td>
                <Element fontFamily="GTAR" fontSize="14px">
                  <strong> Geolocation data, </strong>
                  such as precise physical location.
                </Element>
              </td>
              <td>
                <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
                  Advertising partners.
                </Element>
                <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
                  Third parties as required by law or similar disclosures.
                </Element>
              </td>
            </tr>
            <tr>
              <td>
                <Element fontFamily="GTAR" fontSize="14px">
                  <strong>
                    Professional or employment-related information,
                  </strong>
                  such as job application or resume information.
                </Element>
              </td>
              <td>
                <Element fontFamily="GTAR" fontSize="14px">
                  Vendors and service providers.
                </Element>
                <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
                  Third parties as required by law or similar disclosures.
                </Element>
              </td>
            </tr>
            <tr>
              <td>
                <Element fontFamily="GTAR" fontSize="14px">
                  <strong>Inferences drawn from Personal Information,</strong>
                  including consumer profiles reflecting a consumer’s
                  preferences, characteristics, psychological trends,
                  predispositions, behavior, attitudes, intelligence, abilities,
                  and aptitudes.
                </Element>
              </td>
              <td>
                <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
                  Advertising partners.
                </Element>
                <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
                  Third parties as required by law or similar disclosures.
                </Element>
              </td>
            </tr>
          </tbody>
        </table>
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        The “Information We Collect” section of our Privacy Policy describes the
        categories of sources from which we collect your Personal Information.
        The “How We Use the Information We Collect” section describes the
        purposes for which we collect your Personal Information.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        If you are a California resident, then you can exercise the following
        rights:
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        <ul className={classes.listStyle}>
          <li>
            The right to request a copy of the Personal Information we have
            collected about you in the previous 12 months.
          </li>
          <li>
            The right to request details about the categories of Personal
            Information we collect, the categories of sources, the business or
            commercial purposes for collecting Personal Information, and the
            categories of third parties with whom we share Personal Information.
          </li>
          <li>
            The right to request deletion of the Personal Information we have
            collected about you, subject to certain exemptions.
          </li>
          <li>
            The right to opt out of the sale of your Personal Information.
          </li>
        </ul>
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        Please note that you have the right to make these requests, but we might
        not be able to fulfill certain requests if we are unable to verify your
        identity to the extent required by law.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        California residents can submit access and deletion requests online by
        emailing us at info@thorne.com or by contacting our customer support
        team through our toll-free number: (800)-228-1966. An authorized agent
        can submit an access or deletion request on your behalf by sending a
        written authorization signed by you to info@thorne.com. We can still
        require you to directly verify your identity and confirm that you
        provided the authorized agent permission to submit the request.
      </Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        The CCPA defines "selling" Personal Information to include providing it
        to a third party in exchange for valuable services. We disclose
        identifiers and other internet activity to certain third parties in
        exchange for valuable services, such as to advertising partners and
        analytics partners, which might constitute a "sale" under the CCPA.
        Click here to opt out of the sale of your Personal Information.
      </Element>
      <Element
        fontFamily="GTAR"
        fontSize="14px"
        marginTop="20px"
        marginBottom="20px"
      >
        You have the right to not receive discriminatory treatment for the
        exercise of your CCPA privacy rights, subject to certain limitations.
      </Element>
    </Element>
  );
};

export default PrivacyPolicy;
